import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'filterByGenre' })
export class FilterByGenrePipe implements PipeTransform {
  transform(genreList: any, genre: string): any[] {
    if (genreList) {
      return genreList.filter((listing: any) => listing.genre === genre);
    }
  }
}
